"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../lib/bcdice/arithmetic_evaluator");
require("../lib/bcdice/common_command");
require("../lib/bcdice/base");
require("../lib/bcdice/preprocessor");
var internal_1 = require("./internal");
var result_1 = require("./result");
var Base = /** @class */ (function () {
    function Base(command, internal) {
        this.internal = internal !== null && internal !== void 0 ? internal : internal_1.BCDice.Base.$new(command);
    }
    Base.eval = function (command) {
        var result = internal_1.BCDice.Base.$eval(command);
        return result_1.parseResult(result);
    };
    Object.defineProperty(Base.prototype, "randomizer", {
        get: function () {
            return this.internal.randomizer;
        },
        enumerable: false,
        configurable: true
    });
    Base.prototype.eval = function () {
        var result = this.internal.$eval();
        return result_1.parseResult(result);
    };
    return Base;
}());
exports.default = Base;
//# sourceMappingURL=base.js.map